__turbopack_context__.v({
  "button": "futureFuscia-module-scss-module__ctNduW__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "futureFuscia-module-scss-module__ctNduW__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "futureFuscia-module-scss-module__ctNduW__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "futureFuscia-module-scss-module__ctNduW__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "futureFuscia-module-scss-module__ctNduW__small" + " " + __turbopack_context__.i(693367)["small"],
});
